<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div class="col-xs-12 mycol">
      <table class="co-executor">
        <thead>
          <tr>
            <td>Код ОКПД 2</td>
            <td>Наименование ОКПД 2</td>
            <td>Наименование судна</td>
            <td>Назначение судна</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in rows" v-bind:key="index">
            <td>
              <input type="hidden" v-model="item.ID" />
              <!-- ОКПД по программе всегда 30.11, заполняется бэком -->
              <input
                type="text"
                class="i-main-style i-co-executor-style"
                :value="item.OKPD_CODE || defaultOkpdCode"
                disabled
              />
            </td>
            <td>
              <input
                type="text"
                class="i-main-style i-co-executor-style"
                :value="item.OKPD_NAME || defaultOkpdName"
                disabled
              />
            </td>
            <td
              v-bind:class="{
                'has-error': hasError(index, 'UF_NAME')
              }"
            >
              <textarea-autosize
                type="text"
                class="i-main-style"
                style="width: 95%; min-height: 40px;"
                v-model="item.UF_NAME"
                :maxlength="300"
                :disabled="$parent.$parent.projectDisabled"
                @input="removeError(index,'UF_NAME')"
              />
              <div class="error-text">{{ errorText(index, "UF_NAME") }}</div>
            </td>
            <td
              v-bind:class="{
                'has-error': hasError(index, 'UF_PURPOSE')
              }"
            >
              <textarea-autosize
                type="text"
                class="i-main-style"
                style="width: 95%; min-height: 40px;"
                v-model="item.UF_PURPOSE"
                :maxlength="300"
                :disabled="$parent.$parent.projectDisabled"
                @input="removeError(index,'UF_PURPOSE')"
              />
              <div class="error-text">{{ errorText(index, "UF_PURPOSE") }}</div>
            </td>
            <td>
              <a
                v-if="rows.length > 1 && !$parent.$parent.projectDisabled"
                v-on:click="deleteItem(index)"
                class="link-delete-row"
              ></a>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- судно в проекте одно, поэтому кнопка видна только пока строк нет -->
      <div
        class="add-row"
        v-show="!$parent.$parent.projectDisabled && rows.length < 1"
      >
        <a class="link-add-row" @click="addItem">Добавить судно</a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";

export default {
  name: "ship_info",
  data() {
    return {
      // ОКПД продукции проекта по программе «Лизинг судов» фиксирован
      defaultOkpdCode: "30.11",
      // наименование показываем до первого сохранения, дальше приходит с бэка
      defaultOkpdName: "Корабли, суда и плавучие конструкции"
    };
  },
  computed: {
    ...mapGetters(["project"]),
    rows() {
      const model = this.project.SHIP_INFO;
      if (!model) {
        return [];
      }
      return Array.isArray(model.items) ? model.items : [];
    }
  },
  created() {
    this.ensureModel();
    if (this.rows.length === 0 && !this.$parent.$parent.projectDisabled) {
      this.addItem();
    }
  },
  methods: {
    ensureModel() {
      const model = this.project.SHIP_INFO;
      // бэкенд для пустой модели может отдать массив вместо { items: [] }
      if (!model || !Array.isArray(model.items)) {
        Vue.set(this.project, "SHIP_INFO", { items: [] });
      }
    },
    addItem() {
      this.ensureModel();
      //страховка от повторного вызова: строка в таблице может быть только одна
      if (this.project.SHIP_INFO.items.length > 0) {
        return;
      }
      //ОКПД проставляет бэк, в форме он показывается как 30.11
      this.project.SHIP_INFO.items.push({
        ID: 0,
        UF_OKPD_ID: "",
        OKPD_CODE: "",
        OKPD_NAME: "",
        UF_NAME: "",
        UF_PURPOSE: ""
      });
    },
    deleteItem(index) {
      this.project.SHIP_INFO.items.splice(index, 1);
    },
    hasError(row, field) {
      const errors = this.$parent.$parent.shipInfoErrors;
      return !!(errors[row] && typeof errors[row][field] !== "undefined");
    },
    errorText(row, field) {
      const errors = this.$parent.$parent.shipInfoErrors;
      if (errors[row] && typeof errors[row][field] !== "undefined") {
        return errors[row][field];
      }
      return "";
    },
    removeError(row, field) {
      const errors = this.$parent.$parent.shipInfoErrors;
      if (errors[row] && typeof errors[row][field] !== "undefined") {
        Vue.delete(errors[row], field);
      }
    }
  }
};
</script>

<style scoped></style>
